import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Ranking } from 'src/app/core/models/ranking.model';

@Injectable({
  providedIn: 'root'
})
export class RankingsService {
  private url = '../assets/nfl-ppr-draft.json';

  constructor(private httpService: HttpClient) {
    // this.httpService.get(this.url).subscribe(data => {
    //   this.data = data;
    // },
    // (err: HttpErrorResponse) => {
    //   console.log (err.message);
    // });
  }

  public getRankings(): Observable<Ranking[]> {
    return this.httpService.get<any>(this.url).pipe(
      map(data => data.position_rankings.map(item => new Ranking().deserialize(item)))
    );
  }
}
